export enum RadarDetectionSource {
  RADAR = -1,
  DOCS = 1,
  SYNCED = 0,
}
